import { useEffect, useState } from "react";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DataTable } from "../../DataTable";
import { useUser } from "../../../hooks/useUser";
import { formatTaiwanDateTime, Message } from "../../../utils";
import { GenericModal } from "../../GenericModal/GenericModal";
import { SearchArea } from "./SearchArea";
import { StaffOrderDataColums } from "../../../constants";
import { EditStaffOrderModal } from "../EditStaffOrderModal/EditStaffOrderModal";
import { CreateStaffOrderModal } from "../CreateStaffOrderModal/CreateStaffOrderModal";

import { getDeliverOrders, createDeliverOrder } from "../../../service/api/StaffOrder/apiStaffOrder";
import { getDeliver } from "../../../service/api/Deliver/apiDeliver";
import { roleConfig } from "../../../constants/roleConfig";

const StaffOrderSheet = ({ data, mode, setMode, dataCount, setDataCount }) => {
    const { id, companyId, role } = useUser();
    const [recordsData, setRecordsData] = useState([]);
    const [editRecord, setEditRecord] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [deliversData, setDeliversData] = useState([]);
    const [showSearchArea, setShowSearchArea] = useState(false); // 搜尋區域顯示開關

    // 搜索相關狀態
    const [searchForm, setSearchForm] = useState({
        id: '',
        name: '',
        plate: '',
        employee_name: '',
        status: '',
        company_id: '',
        used_at: '',
        return_at: '',
    });
    const [loading, setLoading] = useState(false);

    // 初始化數據 - 用於非搜索模式
    useEffect(() => {
        if (data) {
            console.log(data);
            setRecordsData(data);
        }
    }, [data]);

    // 執行搜索 - 支持分頁參數
    const handleSearch = async ({ page = 1, limit = 10 }) => {

        setLoading(true);

        try {
            const params = {
                page: page,
                limit: limit,
                id: searchForm.id,
                name: searchForm.name,
                plate: searchForm.plate,
                employee_name: searchForm.employee_name,
                status: searchForm.status,
                company_id: searchForm.company_id,
                used_at: searchForm.used_at,
                return_at: searchForm.return_at,
                mode
            };

            const response = await getDeliverOrders(params);

            if (response.status === 200 && response.data.status === 1) {
                const result = response.data.result;
                const formattedData = result.map(item => ({
                    ...item,
                    usedAt: formatTaiwanDateTime(item.usedAt),
                    returnAt: formatTaiwanDateTime(item.returnAt),
                    finishAt: formatTaiwanDateTime(item.finishAt)
                }));

                setRecordsData(formattedData);
                setDataCount(response.data.count || 0);
            } else {
                Message(response.data.message || '搜尋失敗', 'warning');
            }
        } catch (error) {
            console.error('搜尋錯誤:', error);
            Message('搜尋出錯，請稍後重試', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const query = {};
        if (role === roleConfig['主管'] && mode === 'company' && companyId) {
            query.companyId = companyId;
        } else if ((role < roleConfig['財務'] && mode === 'personal') || (role === roleConfig['員工'] && mode === 'company')) {
            query.id = id;
        }
        if (editRecord || isCreateOpen) {
            getDeliver(query)
                .then(response => {
                    if (response?.status === 200) {
                        console.log(response)
                        setDeliversData(response.data.result);
                    }
                });
        }
    }, [editRecord, isCreateOpen]);

    const allColumns = [
        {
            name: "選擇(未開啟為全選)", cell: row => (
                <label className="small-btn">
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={e => {
                            if (!selectedRows.includes(row.id)) {
                                setSelectedRows(prev => [...prev, row.id]);
                            } else {
                                setSelectedRows(prev => prev.filter(id => id !== row.id));
                            }
                        }}
                    />
                </label>
            ), key: "check"
        },
        ...StaffOrderDataColums,
        {
            name: "操作",
            cell: row =>
                <div className="row-actions">
                    {/* <a className="btn btn-success btn-sm" href="/SKAManager/OrderInfo">查看</a> */}
                    {/* <button className="btn btn-dark btn-sm" onClick={() => setOrderDeliveryStatus(row)} >運送狀態</button > */}
                    {
                        // 當role = 員工 && userUser.id == row.employeeId 時，才顯示編輯按鈕
                        // 當 role == 主管 時，顯示companyId或是 個人 相同的所有派車單編輯按鈕
                        (row.truckLoanApplication?.status === "approved" || !row.truckLoanApplication || row.truckLoanApplication?.status === "repentant") &&
                        (
                            ((role === roleConfig['員工'] && id === row.employeeId) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.employeeId === id) || (role > roleConfig['主管'])) ?
                                <button className="btn btn-action--primary btn-action--sm" onClick={() => setEditRecord(row)} >編輯</button>
                                : null
                        )
                    }
                    {
                        (row.truckLoanApplication?.status === "returned") &&
                        (
                            ((role === roleConfig['員工'] && id === row.employeeId) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.employeeId === id) || (role > roleConfig['主管'])) &&
                            <button className="btn btn-action--confirm btn-action--sm" disabled>已歸還</button>
                        )
                    }
                    {
                        (row.truckLoanApplication?.status === "pending") &&
                        (
                            ((role === roleConfig['員工'] && id === row.employeeId) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.employeeId === id) || (role > roleConfig['主管'])) &&
                            <button className="btn btn-action--gradient btn-action--sm" >審核中</button>
                        )
                    }
                    {
                        (row.truckLoanApplication?.status === "rejected") &&
                        (
                            ((role === roleConfig['員工'] && id === row.employeeId) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.employeeId === id) || (role > roleConfig['主管'])) &&
                            <button className="btn btn-action--danger btn-action--sm" >駁回</button>
                        )
                    }
                    {
                        (row.truckLoanApplication?.status === "cancelled") &&
                        (
                            ((role === roleConfig['員工'] && id === row.employeeId) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.employeeId === id) || (role > roleConfig['主管'])) &&
                            <button className="btn btn-action--warning btn-action--sm" disabled>已取消</button>
                        )
                    }
                </div>,
            key: "action"
        }
    ];

    const filteredAllColumns = allColumns.filter(col => !col.mode || col.mode === mode);
    const [selectedColumns, setSelectedColumns] = useState(
        filteredAllColumns
            .map(col => col.key)
            .filter(key => key !== "check")
    );
    const columnsToShow = filteredAllColumns.filter(col => selectedColumns.includes(col.key));

    // 新增訂單
    const handleAddOrder = async (newOrder) => {
        console.log(newOrder)
        const response = await createDeliverOrder(newOrder);
        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            console.log(response.data);
            setIsCreateOpen(false);
            setRecordsData((prev) => [
                {
                    ...response.data.result,
                    usedAt: formatTaiwanDateTime(response.data.result.usedAt),
                    returnAt: formatTaiwanDateTime(response.data.result.returnAt),
                    truckLoanApplication: response.data.loanApplication || null,
                }, ...prev]);
        } else {
            Message(response.data.message, 'warning');
        }
    };

    return (
        <>
            <GenericModal isOpen={editRecord}>
                <EditStaffOrderModal
                    data={data}
                    order={editRecord}
                    setRecordsData={setRecordsData}
                    onClose={() => setEditRecord(false)}
                    mode={mode}
                    deliversData={deliversData}
                />
            </GenericModal>
            {/* 創建訂單 */}
            <GenericModal isOpen={isCreateOpen}>
                <CreateStaffOrderModal
                    onSubmit={handleAddOrder}
                    onCancel={(e) => { setIsCreateOpen(false); e.preventDefault(); }}
                    mode={mode}
                    deliversData={deliversData}
                />
            </GenericModal>

            <div className="card-header d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-2 gap-md-0">
                <div className="d-flex align-items-center">
                    <h6 className="m-0 fw-bold text-primary">
                        <i className="fas fa-table me-2"></i>派車單列表
                    </h6>
                </div>
                <div className="sheet-actions">
                    <button
                        onClick={() => setMode(mode === 'personal' ? 'company' : 'personal')}
                        disabled={role < roleConfig['財務']}
                        className={`btn btn-action--sm ${mode === 'personal' ? 'btn-action--primary btn-action--soft' : 'btn-action--confirm btn-action--soft'}`}
                        title={role < roleConfig['財務'] ? '該帳號無法切換模式' : ''}
                    >
                        {mode === 'personal' ? '👤 當前個人模式' : '🏢 當前公司模式'}
                    </button>
                    <button
                        onClick={() => setIsCreateOpen(true)}
                        className="btn btn-action--confirm"
                    >
                        <i className="fas fa-plus me-2 "></i>新增派車單
                    </button>
                </div>
            </div>

            {/* 搜尋按鈕 */}
            <div className="d-flex gap-2 border-top sheet-toolbar">
                <button
                    onClick={() => setShowSearchArea(!showSearchArea)}
                    className="btn btn-action--neutral btn-action--soft btn-action--sm"
                    title={showSearchArea ? "隱藏搜尋" : "顯示搜尋"}
                >
                    <FontAwesomeIcon icon={showSearchArea ? faChevronUp : faChevronDown} className="me-2" />
                    {showSearchArea ? '隱藏搜尋' : '顯示搜尋'}
                </button>
            </div>

            {/* 搜尋表單區塊 */}
            {showSearchArea && (
                <SearchArea
                    searchForm={searchForm}
                    setSearchForm={setSearchForm}
                    onSearch={() => handleSearch({ page: 1 })}
                    onReset={() => {
                        setSearchForm({
                            id: '',
                            name: '',
                            plate: '',
                            employee_name: '',
                            status: '',
                            company_id: '',
                            used_at: '',
                            return_at: ''
                        });
                        setRecordsData([]);
                        setDataCount(0);
                    }}
                    loading={loading}
                />
            )}

            <DataTable
                columns={columnsToShow}
                data={recordsData}
                pagination
                noDataComponent="無此訂單資訊"
                paginationComponentOptions={{
                    rowsPerPageText: '每頁筆數',
                    rangeSeparatorText: '總共',
                }}
                paginationMode={{
                    api: handleSearch,
                    count: dataCount,
                    searchFields: {}
                }}
            />

        </>
    );
};

export { StaffOrderSheet };
